import { Pipe, PipeTransform } from '@angular/core';
import { EquipmentModel } from '../../models/equipment-model';

@Pipe({
    name: 'equipmentModel',
    standalone: true
})
export class EquipmentModelPipe implements PipeTransform {
  transform(value: EquipmentModel | null): string {
    if (!value) {
      return '';
    }
    return `${value.manufacturer ?? ''} ${value.model ?? ''}`.trim();
  }
}
